import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { WdxIconModule } from '@wdx/shared/components/wdx-icon';
import {
    TranslateTokenisedStringPipe,
    WdxDestroyClass,
    WdxMarkdownToHtmlPipe,
    WdxSafeHtmlPipe,
} from '@wdx/shared/utils';

import { WdxIconButtonModule } from '@wdx/shared/components/wdx-icon-button';
import { WdxSpinnerModule } from '@wdx/shared/components/wdx-spinner';
import {
    WdxToastHeaderIsTemplatePipe,
    WdxToastHeaderTextPipe,
} from './wdx-toast-header.pipe';
import { Toast } from './wdx-toast.model';
import { WdxToastService } from './wdx-toast.service';

@Component({
    selector: 'wdx-toast',
    imports: [
        CommonModule,
        RouterModule,
        WdxIconModule,
        NgbToastModule,
        WdxMarkdownToHtmlPipe,
        WdxSafeHtmlPipe,
        WdxSpinnerModule,
        WdxIconButtonModule,
        WdxIconModule,
        TranslateTokenisedStringPipe,
        WdxToastHeaderIsTemplatePipe,
        WdxToastHeaderTextPipe,
    ],
    templateUrl: './wdx-toast.component.html',
    styleUrls: ['./wdx-toast.component.scss'],
    host: {
        class: 'toast-container d-block position-fixed top-0 start-50 translate-middle-x z-index-999 mt-4',
    },
})
export class WdxToastComponent extends WdxDestroyClass {
    public wdxToastService = inject(WdxToastService);

    protected DEFAULT_CLOSE_DELAY_MS = 5000;

    getTemplateContext(toast: Toast): Record<string, unknown> {
        return {
            $implicit: toast,
            ...(toast.templateContext || {}),
        };
    }
}
